import { render } from "./AppNotification.vue?vue&type=template&id=4d8fb4b2&scoped=true"
import script from "./AppNotification.vue?vue&type=script&lang=js"
export * from "./AppNotification.vue?vue&type=script&lang=js"

import "./AppNotification.vue?vue&type=style&index=0&id=4d8fb4b2&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8fb4b2"]])

export default __exports__